var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserImageEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2157 2.28888e-05C13.9543 -6.23385e-05 14.6626 0.29329 15.1847 0.815563C16.2719 1.90285 16.2717 3.66561 15.1844 4.75277L5.60476 14.3324C5.52495 14.4123 5.42757 14.4726 5.3204 14.5084L0.95674 15.9629C0.882592 15.9873 0.804992 15.9999 0.726923 16C0.649025 15.9999 0.571595 15.9873 0.49766 15.9627C0.116565 15.8358 -0.0894734 15.424 0.0374733 15.0429L1.49201 10.6793C1.52785 10.5723 1.58781 10.475 1.66728 10.3949L11.247 0.816032C11.7678 0.291756 12.4768 -0.00210779 13.2157 2.28888e-05ZM4.70148 13.1797L14.1561 3.7251C14.406 3.47606 14.546 3.13754 14.5452 2.78474C14.5441 2.43382 14.4044 2.09755 14.1565 1.84916C13.6376 1.32919 12.7953 1.32833 12.2753 1.84728L2.81709 11.3018L1.87673 14.1229L4.70148 13.1797Z",
    fill: "#B2D235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImageEdit);
export default __webpack_public_path__ + "static/media/user-image-edit.a5f0ab66.svg";
export { ForwardRef as ReactComponent };